import { render, staticRenderFns } from "./perfilUsuario.vue?vue&type=template&id=363d3c23&"
import script from "./perfilUsuario.vue?vue&type=script&lang=js&"
export * from "./perfilUsuario.vue?vue&type=script&lang=js&"
import style0 from "./perfilUsuario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports